import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralHttpService } from 'src/app/shared/general-http.service';

@Injectable({
  providedIn: 'root'
})
export class UserComercialService {
  private readonly route = 'SegTipoPersonas'
  private routeApi = "SegUsuarios";
  constructor(private generalHttp:GeneralHttpService) { }

  GetTipoUsuarioUserComercial(){
    return this.generalHttp.getHttp(`${this.route}/GetTipoUsuarioUserComercial`);
  }

  saveUserComercial(form:any,idUser:number){
    return this.generalHttp.postHttp(form,`${this.routeApi}/SaveUserComercial/${idUser}`);
  }
  

  getUsers(id: number) {
    return this.generalHttp.getHttpById(id, this.routeApi);
  }


  updateUserComercial(form:any,idUser:number){
    return this.generalHttp.putHttp(form,idUser,`${this.routeApi}/UpdateUserComercial`);
  }

}
